import React from "react"
import { Link } from "gatsby"

import Image from "./image"

const Footer = () => (
  <div className="footer">
    <div className="container">
      <div className="columns">
        <div className="column">
          <div className="logo">
            <a href="https://picks.fun/">
              <Image filename="logo-white.png" />
            </a>
          </div>
        </div>
        <div className="column mt-40-mobile has-text-left-desktop">
          <div className="link">
            <Link className="has-text-white" to="/PicksforPartners">
              飲食店の方へ
            </Link>
          </div>
          <div className="link">
            <a
              className="has-text-white"
              href="https://picksfun.zendesk.com/hc/ja"
              target="_blank"
            >
              よくある質問
            </a>
          </div>
          <div className="link">
            <Link className="has-text-white" to="/PicksforPartners/inquiry">
              お問い合わせ
            </Link>
          </div>
        </div>
        <div className="column has-text-left-desktop">
          <div className="link">
            <Link className="has-text-white" to="/terms">
              利用規約
            </Link>
          </div>
          <div className="link">
            <Link className="has-text-white" to="/policy">
              プライバシーポリシー
            </Link>
          </div>
          <div className="link">
            <a
              className="has-text-white"
              href="http://dirigio.jp/"
              target="_blank"
            >
              運営会社
            </a>
          </div>
        </div>
        <div className="column mt-40-mobile">
          <div className="store">
            <div className="logo">
              <a
                href="https://itunes.apple.com/us/app/picks-%E3%83%94%E3%83%83%E3%82%AF%E3%82%B9/id1348648665?l=ja&amp;ls=1&amp;mt=8"
                target="_blank"
              >
                <Image filename="logo-app-store.png" />
              </a>
            </div>
            <div className="logo">
              <a
                href="https://play.google.com/store/apps/details?id=fun.picks.picks"
                target="_blank"
              >
                <Image filename="logo-google-play.png" />
              </a>
            </div>
          </div>
        </div>
        <div className="column mt-40-mobile">
          <div className="sns">
            <div className="logo">
              <a
                href="https://www.facebook.com/Picks-968358393313986/"
                target="_blank"
              >
                <Image filename="logo-facebook.png" />
              </a>
            </div>
            <div className="logo ml-14 mr-14">
              <a href="https://twitter.com/picks_fun" target="_blank">
                <Image filename="logo-twitter.png" />
              </a>
            </div>
            <div className="logo">
              <a href="https://www.instagram.com/picks_fun/" target="_blank">
                <Image filename="logo-instagram.png" />
              </a>
            </div>
          </div>
          <div className="copyright mt-40-mobile">
            <div>© DIRIGIO INC. ALL RIGHTS RESERVED</div>
            <div></div>
            <div>TEL: 050-3627-0048</div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default Footer
